import { Utils } from "@react-awesome-query-builder/core";
import { validationTranslateOptions } from "./useValidation";

export const queryValidation = (state) => {
  const { tree: immutableTree, config } = state;

  const validationRes = Utils.validateTree(immutableTree, config, {
    ...validationTranslateOptions,
  }).map(({
    errors, itemStr, itemPositionStr,
  }) => ({
    errors: errors.map(({
      side, delta, str, fixed
    }) => {
      // Check if the error is about "Incomplete LHS" for a8NoOperator
      if (side === "lhs" && str.includes("Incomplete LHS")) {
        // Get the current tree to check if it's using a8NoOperator
        const tree = immutableTree.toJSON();
        // You might need to traverse to find the specific rule
        // For now, we'll check globally
        const hasNoOperator = JSON.stringify(tree).includes('"a8NoOperator"');
        if (hasNoOperator) {
          // Skip this error for a8NoOperator rules
          return null;
        }
      }
      return `${fixed ? "* " : ""}${side ? `[${[side, delta].filter(a => a != undefined).join(" ")}] ` : ""}${str}`;
    }).filter(error => error !== null), // Remove null errors
    itemStr,
    itemPositionStr,
  })).filter(item => item.errors.length > 0); // Only keep items with actual errors

  return validationRes.length > 0 ? JSON.stringify(validationRes, undefined, 2) : '';
}